<template>
  <div id="app">
    <Layout />
    <ProgressCircular v-if="isLoading" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from "vue";
import Layout from "@/layouts/Layout.vue";
import ProgressCircular from "@/components/progress/ProgressCircular.vue";
import loadingService from "@/services/loading";

const isLoading = computed(() => loadingService.loading);

const resize = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

onMounted(() => {
  window.addEventListener("resize", resize);
  resize();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
});
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
}
</style>
